const BC_CODE = '026';
const UNION_PAY_CODE = '081';
const MASTER_CODE = '049';

const KB_CODE = '016';

const HANA_CODE = '006';
const HANA_EXTERNAL_CODE = '008';

const SHINHAN_CODE = '029';
const JEJU_CODE = '011';
const AMEX_CODE = '046';

const WOORI_CODE = '015';
const SUHYUP_CODE = '017';
const NH_CODE = '018';
const CITY_CODE = '022';
const JCB_CODE = '028';
const SAMSUNG_CODE = '031';
const VISA_CODE = '050';
const GWANGJU_CODE = '002';
const JUNBUK_CODE = '010';

const LOTTE_CODE = '047';

const HYUDAI_CODE = '027';
const SSG_CODE = '034';
const DINERS_CODE = '048';

const redCodes = [BC_CODE, UNION_PAY_CODE, MASTER_CODE];
const yellowCodes = [KB_CODE];
const greenCodes = [HANA_CODE, HANA_EXTERNAL_CODE];
const blueCodes = [SHINHAN_CODE, JEJU_CODE, AMEX_CODE];
const navyCodes = [WOORI_CODE, SUHYUP_CODE, NH_CODE, CITY_CODE,
    JCB_CODE, SAMSUNG_CODE, VISA_CODE, GWANGJU_CODE, JUNBUK_CODE];
const purpleCodes = [LOTTE_CODE];
const blackCodes = [HYUDAI_CODE, SSG_CODE, DINERS_CODE];

const NAVY_COLOR = '#333CBA';
const RED_COLOR = '#FF3D19';
const BLUE_COLOR = '#35AFFD';
const BLACK_COLOR = '#36363A';
const GREEN_COLOR = '#009858';
const YELLOW_COLOR = '#FBC500';
const PURPLE_COLOR = '#A813CD';
const SKY_BLUE_COLOR = '#12D4E3';

export function getColorByIssuerCode(code?: string) {
    if (!code) {
        return SKY_BLUE_COLOR;
    }
    if (navyCodes.includes(code)) {
        return NAVY_COLOR;
    }
    if (redCodes.includes(code)) {
        return RED_COLOR;
    }
    if (blueCodes.includes(code)) {
        return BLUE_COLOR;
    }
    if (blackCodes.includes(code)) {
        return BLACK_COLOR;
    }
    if (greenCodes.includes(code)) {
        return GREEN_COLOR;
    }
    if (yellowCodes.includes(code)) {
        return YELLOW_COLOR;
    }
    if (purpleCodes.includes(code)) {
        return PURPLE_COLOR;
    }
    return SKY_BLUE_COLOR;
}
